import { Navbar, Container, Image, Button, Dropdown } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useTr } from '../../hooks/useTr';
import logo from '../../assets/img/logo-conduto.png';
import logoEcuador from '../../assets/img/LogoEcuador.jpg';
import logoPeru from '../../assets/img/LogoPeru.jpg';
import LogoBrasil from '../../assets/img/LogoBrasil.png';
import LanguageSelector from '../LanguageSelector';
import TranslatingIndicator from '../TranslatingIndicator';
import './Navbar.css';

const CustomNavbar = ({ onToggleSidebar, username = "Usuario" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tr = useTr();
  const [usuarioData, setUsuarioData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargarUsuario = () => {
      try {
        const usuarioStorage = localStorage.getItem('usuario');

        if (usuarioStorage) {
          const usuarioParsed = JSON.parse(usuarioStorage);
          setUsuarioData(usuarioParsed);
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      } finally {
        setLoading(false);
      }
    };

    cargarUsuario();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    navigate('/administrador/login');
  };

  const isAdmin = () => {
    return usuarioData && usuarioData.rol === 'admin';
  };

  const getUsername = () => {
    if (usuarioData) {
      return usuarioData.nombre || usuarioData.usuario || "Usuario";
    }
    return username;
  };

  const isHojasVidaRoute = location.pathname === '/administrador/hojas-vida';
  const usuarioEsAdmin = isAdmin();

  if (loading) {
    return null;
  }

  return (
    <Navbar bg="white" variant="light" fixed="top" className="shadow-sm py-2 custom-navbar">
      <Container fluid className="flex-wrap row-gap-2 px-2 px-sm-3">
        <div className="d-flex align-items-center flex-shrink-0" style={{ minWidth: 0 }}>
          <Image
            src={logo}
            alt="Logo Empresa"
            className="d-inline-block align-top flex-shrink-0 navbar-logo-main"
            fluid
          />
          <Image
            src={logoEcuador}
            alt="Logo Empresa"
            className="d-inline-block align-top ms-2 flex-shrink-0 navbar-logo-sm"
            fluid
          />
          <Image
            src={logoPeru}
            alt="Logo Empresa"
            className="d-inline-block align-top ms-2 flex-shrink-0 navbar-logo-sm"
            fluid
          />

          <Image
            src={LogoBrasil}
            alt="Logo Empresa"
            className="d-inline-block align-top ms-2 flex-shrink-0 navbar-logo-sm"
            fluid
          />
        </div>

        <div className="ms-auto d-flex align-items-center gap-2 gap-md-3 flex-shrink-0">
          <TranslatingIndicator />
          <LanguageSelector />

          {usuarioEsAdmin && isHojasVidaRoute && (
            <>
              <div className="d-none d-md-flex align-items-center">
                <span className="navbar-username me-3">
                  <strong>{getUsername()}</strong>
                </span>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={handleLogout}
                  className="logout-btn"
                >
                  <i className="bi bi-box-arrow-right me-1"></i>
                  {tr('Cerrar Sesión')}
                </Button>
              </div>

              <Dropdown className="d-md-none">
                <Dropdown.Toggle
                  variant="outline-secondary"
                  size="sm"
                  id="dropdown-user"
                  className="user-dropdown-toggle"
                >
                  <i className="bi bi-person-circle"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  <Dropdown.Header>
                    {getUsername()}
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout} className="text-danger">
                    <i className="bi bi-box-arrow-right me-2"></i>
                    {tr('Cerrar Sesión')}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          )}
        </div>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;